import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { History } from './types'

export const historyMounted = createEvent<string>()

export const getHistories = fx<string, History[]>({
  method: 'GET',
  url: `/cardVerification?where{"clientId":"1"}`,
})

export const $history = restore<History[]>(
  getHistories.doneData.map((doneData) => doneData.body),
  [],
)

sample({
  clock: [historyMounted],
  fn: (id) => {
    return {
      url: `/cardVerification?where={"clientId":"${id}"}`,
    }
  },
  target: [getHistories],
})
